export default "__VITE_ASSET__DpvYQXSn__"